export const messageFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'messages.status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.fields.status.read.label',
        value: 'read',
      },
      {
        text: 'global.fields.status.unread.label',
        value: 'unread',
      },
    ],
    id: 'global-message__status',
    veeValidation: true,
    rules: [],
  },
  sender_receiver_id: {
    fieldPath: 'fullname',
    fieldReadPath: 'fullname',
    name: 'sender_receiver_id',
    label: 'messages.contacts.label',
    inputType: 'entity-select',
    options: [],
    id: 'global-message__sender-receiver-id',
    veeValidation: true,
    rules: [],
  },
  date: {
    fieldPath: 'created_at',
    fieldReadPath: 'created_at',
    name: 'date',
    label: 'messages.created_at.label',
    inputType: 'datepicker',
    id: 'global-message__date',
    veeValidation: true,
    rules: [],
  },
};

export const messageDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'read', label: 'global.fields.status.read.label' },
      { value: 'unread', label: 'global.fields.status.unread.label' },
    ],
    valueToVariant: [
      { value: 'read', variant: 'success' },
      { value: 'unread', variant: 'warning' },
    ],
  },
  receivers: {
    displayType: 'array',
    fieldPath: 'fullname',
    fieldReadPath: 'fullname',
  },
  channels: {
    displayType: 'array',
    valueToLabel: [
      { value: 'internal', label: 'global.fields.channels.internal.label' },
      { value: 'mail', label: 'global.fields.channels.mail.label' },
    ],
  },
};

export const messageFields = {
  sender_id: {
    fieldPath: 'sender_id',
    fieldReadPath: 'sender_id',
    name: 'sender_id',
    label: 'global.sender.label',
    inputType: 'input',
    options: [],
    id: 'global-message_sender_id',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.status.label',
    options: [
      { value: 'read', text: 'global.fields.status.read.label' },
      { value: 'unread', text: 'global.fields.status.unread.label' },
    ],
    valueToColor: [
      { value: 'read', color: 'border-0 text-white bg-success' },
      { value: 'unread', color: 'border-0 text-white bg-warning' },
    ],
    id: 'global-message__status',
    rules: [],
    placeholder: 'messages.status.label',
  },
  receivers: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'receivers',
    label: 'messages.receivers.label',
    options: [],
    id: 'selects-message__receivers',
    rules: [],
    placeholder: 'messages.receiverse.label',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectValue: 'id',
    selectMultiple: false,
  },
  title: {
    fieldPath: 'title',
    fieldReadPath: 'title',
    name: 'title',
    label: 'messages.title.label',
    options: [],
    id: 'global__title',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  message: {
    fieldPath: 'message',
    fieldReadPath: 'message',
    name: 'message',
    label: 'messages.message.label',
    options: [],
    id: 'global__message',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
};
